import { GoogleGenAI, Type } from "@google/genai";
import { TruckSpecs, PalletConfig } from '../types';

const getAiClient = () => {
  const apiKey = process.env.API_KEY;
  if (!apiKey) {
    throw new Error("API Key is missing. Please set REACT_APP_GEMINI_API_KEY.");
  }
  return new GoogleGenAI({ apiKey });
};

export const parseManifest = async (text: string): Promise<Partial<PalletConfig>[]> => {
  try {
    const ai = getAiClient();
    
    const prompt = `
      Extract cargo items from the following text (which might be from an email, Excel, or chat).
      Return a JSON array of objects.
      
      Rules:
      1. Detect 'quantity', 'length', 'width', 'height', 'weight', and 'name'.
      2. If units are not specified, ASSUME Centimeters (cm) for dimensions and Kilograms (kg) for weight.
      3. If dimensions are in meters, convert to cm.
      4. If 'stackable' is mentioned (e.g., "remontable", "stackable"), set stackable to true.
      5. Infer 'name' if not explicit (e.g., "Europallet", "Box", "Crate").
      6. Return ONLY the JSON array.
      
      Text to analyze:
      "${text}"
    `;

    const response = await ai.models.generateContent({
      model: 'gemini-2.5-flash',
      contents: prompt,
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.ARRAY,
          items: {
            type: Type.OBJECT,
            properties: {
              name: { type: Type.STRING },
              quantity: { type: Type.NUMBER },
              length: { type: Type.NUMBER, description: "Length in cm" },
              width: { type: Type.NUMBER, description: "Width in cm" },
              height: { type: Type.NUMBER, description: "Height in cm" },
              weight: { type: Type.NUMBER, description: "Weight per unit in kg" },
              stackable: { type: Type.BOOLEAN }
            },
            required: ["quantity", "length", "width", "height", "weight", "name"]
          }
        }
      }
    });

    if (response.text) {
        return JSON.parse(response.text);
    }
    return [];

  } catch (error) {
    console.error("Error parsing manifest:", error);
    return [];
  }
};